module.exports = __webpack_public_path__ + "img/ActionLogging.5209bedb.svg";